export function asArray(value) {
  return Array.isArray(value) ? value : [];
}

export function getCvExtractedEmploymentRecords(employee = {}, cvExtractionResult = null) {
  const direct = asArray(employee?.cv_extracted_employment_history);
  if (direct.length) return direct;

  const nested = asArray(employee?.cv_extraction?.employment_history);
  if (nested.length) return nested;

  return asArray(cvExtractionResult?.employment_history);
}

export function normaliseCanonicalEmploymentForEditing(records = []) {
  return asArray(records).map((record) => {
    const raw = record?.raw_record || record || {};
    const employer = raw.employer || raw.company || raw.employer_name || record?.employer || record?.organisation || '';
    const jobTitle = raw.job_title || raw.role || raw.position || record?.job_title || record?.role || record?.title || '';
    const endDate = raw.end_date || raw.to_date || record?.end_date || '';
    return {
      ...raw,
      id: raw.id || record?.source_record_id || record?.id,
      employer,
      company: raw.company || employer,
      employer_name: raw.employer_name || employer,
      job_title: jobTitle,
      role: raw.role || jobTitle,
      start_date: raw.start_date || raw.from_date || record?.start_date || '',
      end_date: endDate === 'present' ? '' : endDate,
      is_current: Boolean(raw.is_current || endDate === 'present' || !endDate),
      responsibilities: raw.responsibilities || raw.duties || '',
    };
  });
}

export function getEditableEmploymentHistory(employeeHistory = [], canonicalEmploymentRecords = []) {
  const savedEmployeeHistory = asArray(employeeHistory);
  if (savedEmployeeHistory.length) return savedEmployeeHistory;
  return normaliseCanonicalEmploymentForEditing(canonicalEmploymentRecords);
}

export function getEmploymentHistoryEmptyState({
  canonicalEmploymentRecords = [],
  cvExtractedEmploymentRecords = [],
} = {}) {
  if (asArray(canonicalEmploymentRecords).length) return null;
  if (asArray(cvExtractedEmploymentRecords).length) {
    return {
      title: 'Official work history is missing',
      detail: 'Roles were found in the CV, but the applicant still needs an official work history before this section can be signed off.',
    };
  }
  return {
    title: 'Work history is missing',
    detail: 'Ask the applicant to add their 10-year work history before signing off this section.',
  };
}
